import BaseHeadline from "../../../components/general/BaseHeadline"
import BaseIcon from "../../../components/general/BaseIcon"

type FunctionCardType = {
    headline: string
    iconName: string
    theme?: "primary" | "secondary"
}

export default function FunctionCard(props: FunctionCardType) {
    return (
        <div
            className={`flex items-center shrink-0 w-sm md:w-[24rem] border border-[#2A2826] p-3 md:p-4 gap-2 rounded-2xl ${props.theme === "secondary" ? "hover:bg-secondary/10" : "hover:bg-primary/10"} duration-500`}>
            <BaseHeadline headline={props.headline} tag="h6" headlineClassProps="font-[500] -mb-4 text-base-content flex-1" />

            <div
                className={`${props.theme === "secondary" ? "text-secondary bg-secondary/20" : " text-primary bg-primary/20"} p-3 md:p-4 w-fit aspect-square rounded-2xl`}>
                <BaseIcon name={props.iconName} size={40} />
            </div>
        </div>
    )
}
